"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconMap = exports.ReassuranceInsightIcon = exports.DeviationRiskInsightIcon = exports.useIconBg = exports.activityIconTestIds = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const silhouette_core_1 = require("@freighthub/silhouette-core");
exports.activityIconTestIds = {
    reassuranceIcon: 'activity-reassurance_insight_icon',
    deviationRiskIcon: 'activity-deviation_risk-icon',
    deviationIcon: 'activity-deviation-icon',
    approvalIcon: 'activity-approval-icon',
    messageIcon: 'activity-message-icon',
    updateIcon: 'activity-update-icon',
    openTaskIcon: 'activity-open_task-icon',
};
const useIconBg = () => {
    const { palette } = (0, silhouette_core_1.useTheme)();
    return {
        deviationRisk: palette.tag.warning,
        deviation: palette.tag.error,
        update: palette.grey['300'],
        reassurance: palette.tag.success,
        approval: palette.tag.info,
    };
};
exports.useIconBg = useIconBg;
const DeviationRiskInsightIcon = () => {
    const { palette } = (0, silhouette_core_1.useTheme)();
    return (0, jsx_runtime_1.jsx)(silhouette_core_1.WarningIcon, { htmlColor: palette.status.warning, "data-testid": exports.activityIconTestIds.deviationRiskIcon });
};
exports.DeviationRiskInsightIcon = DeviationRiskInsightIcon;
const ReassuranceInsightIcon = () => {
    const { palette } = (0, silhouette_core_1.useTheme)();
    return (0, jsx_runtime_1.jsx)(silhouette_core_1.CheckBoxIcon, { htmlColor: palette.status.success, "data-testid": exports.activityIconTestIds.reassuranceIcon });
};
exports.ReassuranceInsightIcon = ReassuranceInsightIcon;
exports.IconMap = {
    deviationRisk: exports.DeviationRiskInsightIcon,
    deviation: () => (0, jsx_runtime_1.jsx)(silhouette_core_1.ErrorIcon, { color: "error", "data-testid": exports.activityIconTestIds.deviationIcon }),
    reassurance: exports.ReassuranceInsightIcon,
    approval: () => (0, jsx_runtime_1.jsx)(silhouette_core_1.AssignmentTurnedInIcon, { color: "primary", "data-testid": exports.activityIconTestIds.approvalIcon }),
    openTasks: () => (0, jsx_runtime_1.jsx)(silhouette_core_1.AssignmentIcon, { color: "primary", "data-testid": exports.activityIconTestIds.openTaskIcon }),
    message: () => (0, jsx_runtime_1.jsx)(silhouette_core_1.MessageIcon, { color: "action", "data-testid": exports.activityIconTestIds.messageIcon }),
    update: () => (0, jsx_runtime_1.jsx)(silhouette_core_1.AutorenewIcon, { color: "action", "data-testid": exports.activityIconTestIds.updateIcon }),
};
//# sourceMappingURL=ActivityIcons.js.map